import { Link, useLocation } from "react-router-dom";
import { Home } from "lucide-react";
import { useAuth } from "../context/AuthContext";

/**
 * Floating Action Button "Home Accademia"
 * Visibile solo per cliente_accademia, su ogni pagina tranne quando è già sulla home (/biblioteca).
 * Mostra anche un mini-link "Scienza del Benessere" per facilitare la navigazione.
 */
export default function HomeFab() {
  const { user } = useAuth();
  const location = useLocation();

  if (!user || user.role !== "cliente_accademia") return null;

  const homePath = "/biblioteca";
  const isOnHome = location.pathname === homePath || location.pathname.startsWith("/biblioteca");
  if (isOnHome) return null;

  return (
    <Link
      to={homePath}
      className="fixed bottom-6 left-6 lg:bottom-8 lg:left-8 z-[90] flex items-center gap-2 px-4 sm:px-5 py-3 rounded-full bg-gradient-to-r from-[#7A4856] to-[#5A3340] text-white shadow-2xl hover:shadow-xl hover:scale-105 transition-all duration-200"
      data-testid="fab-home-accademia"
    >
      <Home className="w-5 h-5" />
      <span className="text-sm font-medium hidden sm:inline">Home Accademia</span>
    </Link>
  );
}
